const actions = {
    // 获取项目名称和后台用户列表
    // getMenuList(ctx, item) {
    //     api.request("/skn/findProjectNameMenuAndEmployeeMenuList", {}, (res) => {
    //         ctx.commit('menuList', res.data);
    //     });
    // },
    // 皮肤科消费表获取所有信息列表
    getIdList(ctx, item) {
        api.requestQuiet("/skn/findMenuList", {}, (res) => {
            ctx.commit('idList', res.data);
        });
    },

    //登记表外科获取所有列表接口
    getDataList(ctx, item) {
        api.requestQuiet("/register/findSurgeryRegisterMenuList", {}, (res) => {
            ctx.commit('allData', res.data);
        });
    },
    //登记表皮肤科获取所有列表接口
    getallList(ctx, item) {
        api.requestQuiet("/register/findDermatologyRegisterMenuList", {}, (res) => {
            ctx.commit('allList', res.data);
        });
    },
    // 登记表获取所有科室列表
    getDepartment(ctx, item) {
        api.requestQuiet("/register/findByDepartmentMenuList", {}, (res) => {
            ctx.commit('departmentList', res.data);
        });
    },


    // 交接记录获取护士列表
    getnurseNoList(ctx, item) {
        api.requestQuiet("/employee/findEmployeeListAll", {}, (res) => {
            ctx.commit('nurseNoList', res.data.createByList);
        });
    },


     // 医嘱列表
     getOrderList(ctx, item) {
        api.requestQuiet("/leaveObserve/findDrugMenuByAll", {}, (res) => {
            ctx.commit('orderList', res.data);
        });
    },
     
     //留观管理获取医生护士列表
     getNurseMenuList(ctx, item) {
        api.requestQuiet("/register/findSurgeryRegisterMenuNameList", {}, (res) => {
            ctx.commit('nurseMenuList', res.data);
        });
    },
     

}
export default actions